<link href="https://fonts.googleapis.com/css?family=Comfortaa:700&display=swap" rel="stylesheet">

<style>
#header {
	background: none;
	color: grey;
	background-color: white;
	display: flex;
	box-shadow: 0px 0px 5px lightgrey;
	user-select: none;
	z-index: 100;
	min-height: 65px;
}

#extended-bar-holder {
	flex: 1;
	display: flex;
	flex-direction: row;
}


#logo {
	font-size: 22px;
	cursor: pointer;
	color: black;
	font-family: 'Comfortaa', sans-serif;
}

#logo:hover {
	opacity: 0.7;		
}

.logo-img {
	margin: 10px;
	margin-right: 0px;
	float: left;
	height: 40px;
}

.logo-text {
	display: inline-block;
	padding: 20px;
	padding-left: 5px;
}

#controls {
	padding-top: 17px;
}

button {
	color: white;
	border: none;
	font-size: 14px;
	margin: 0px;
	margin-left: 5px;
}

button:hover {
	background-color: #ebebf3;
    color: grey;
}

#links {
	padding: 23px;
	text-align: right;
	flex: 1;
	font-size: 14px;
}

#search {
	padding-top: 17px;
	padding-left: 25px;
	flex: 1;
	max-width: 250px;
}

a {
	color: grey;
	margin-left: 10px;
}

a:hover {
	color: black;
}

.user-name {
	color: grey;
}

input {
	-webkit-appearance: none;
	padding: 8px !important;
	background-color: rgb(51, 51, 51);
	color: white;
	border: none;
	font-size: 14px;
	width: 250px;
	outline: none;
}

.notification-badge {
	background-color: silver;
	padding-left: 5px;
	padding-right: 5px;
	border-radius: 5px;
	color: white;
}

.notification-badge-waiting {
	background-color: orange;
}

.inbox-link-waiting {
	color: orange;
}

.search-suggestions {
	position: fixed;
	background-color: white;
	color: rgb(184, 184, 184);
	z-index: 10;
	width: 250px;
	border-radius: 15px;
	overflow: hidden;
	font-size: 14px;
	box-shadow: 0px 2px 4px lightgrey;
}

.search-result {
	cursor: pointer;
	padding: 10px;
}

.search-result:hover {
	background-color: rgb(235, 235, 243);
	color: grey;
}

.hamb-holder {
	display: inline-block;
	width: 35px;
	padding-top: 18px;
	padding-right: 15px;
}
.hamb {
	width: 35px;
	height: 2px;
	background-color: black;
	margin: 4px 0;
}

#menu-button {
	display: none;
}

#logo-and-menu {
	display: flex;
}


.dropdown {
	position: relative;
	display: inline-block;
	margin-left: 10px;
}

.dropdown-content {
	display: none;
	position: absolute;
	background-color: white;
	color: black;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	padding: 12px 16px;
	z-index: 1;
	right: 0;
	border-radius: 15px;
}

.dropdown:hover .dropdown-content {
display: block;
}

.dropdown-content a {
	display: block;
	color: rgb(0,100,200);
	padding: 2px;
}

.search-input {
	background-color: rgb(235, 235, 243);
	color: grey;
	border-radius: 15px;
	padding: 8px !important;
	min-width: 100%;
}

.username-display {
	color: black;
	font-weight: bold;
}

.badge {
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    color: white;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: rgb(123, 123, 123);
    cursor: pointer;
}

/*Special*/
.badge-special {
    padding: 5px;
    border-radius: 15px;
    color: grey;
    font-size: 12px;
    display: inline-block;
    line-height: 1em;
    background-color: ghostwhite;
}

.verified-badge-holder {
	width: 200px;
	margin-bottom: 10px;
	margin-top: 10px;
}

.tools-button {
	background-color: white;
	color: grey;
	border: 1px solid rgb(223, 223, 223);
	padding-left: 10px;
	padding-right: 10px;
}
.tools-button:hover {
	background-color: #ebebf3 !important;
}

.tools-link {
	background-color: black;
	color: white;
	padding: 4px;
	border-radius: 7px;
	display: inline-block;
}

.tools-link:hover {
	background-color: rgb(70, 70, 70);
	color: white;
}

.search-suggestion-header {
	padding: 10px;
	color: grey;
}

.add-button {
	background-color: #424242;
	padding-left: 10px;
	padding-right: 10px;
}

.add-button:hover {
	background-color: grey;
	color: white;
}

@media (max-width:972px) {
	#extended-bar-holder {
		flex-direction: column;
		background-color: white;
		box-shadow: 0px 2px 5px -2px lightgrey;
	}

	#search, #links {
		text-align: left;
		padding: 10px;
	}

	#controls {
		text-align: right;
		padding: 10px;
		padding-left: 0px;
		padding-top: 16px;
		flex: 1;
		
	}

	.controls-holder {
		text-align: right;
		display: inline-block;
	}

	#logo {
		font-size: 18px;
		cursor: pointer;
		color: black;
		font-family: 'Comfortaa', sans-serif;
	}

	#logo:hover {
		opacity: 0.7;		
	}

	.logo-img {
		margin: 10px;
		margin-right: 0px;
		float: left;
		height: 35px;
	}

	.logo-text {
		display: inline-block;
		padding-top: 20px;
		padding-bottom: 0px;
		padding-left: 5px;
		padding-right: 5px;
	}

	#header  {
		flex-direction: column;
		border: none;
		min-height: 55px;
	}

	#links {
		padding: 10px;
	}

	#menu-button {
		display: block;
		flex: 1;
		text-align: right;
	}
	
	a {
		margin-bottom: 20px;
		display: block;
	}

	#search {
		max-width: calc(100% - 20px);
		width: calc(100% - 20px);
	}

	.search-input {
		width: 250px;
	}

	button {
		opacity: 1.0;
		font-size: 12px;
		padding: 5px;
	}

	.search-suggestions {
		width: calc(100% - 20px);
	}

	.dropdown-content {
		display: block;
		position: relative;
		background-color: white;
		padding-left: 0px;
		box-shadow: none;
		text-align: center;
	}

	.dropdown-content a {
		display: inline;
		margin-left: 0px;
		margin-right: 10px;
	}
}
</style>

<script>
import {push,location,replace} from './pt-router/Router.svelte'
import {onMount} from 'svelte'
import { slide } from 'svelte/transition';
import * as Common from './Common.js'
import Spinner from './Spinner.svelte'

export let showExtendedBar;
export let municipalUser = false;

let searchQuery = "";
let currentUser;
let currentUserArea;
let notificationCount = 0;
let inboxLinkClass = ""
let inboxBadgeClass = "notification-badge"

$: filteredAreas = []

$: filteredTags = null

$: $location && currentUser && Common.getData('notification/count').then(data => {
	notificationCount = data.count
	inboxLinkClass = notificationCount == 0 ? "" : "inbox-link-waiting"
	inboxBadgeClass = notificationCount == 0 ? "notification-badge" : "notification-badge notification-badge-waiting"
})

onMount(async () => {	
	if(currentUser) {
		Common.getData('notification/count').then(data => {
			notificationCount = data.count
			inboxLinkClass = notificationCount == 0 ? "" : "inbox-link-waiting"
			inboxBadgeClass = notificationCount == 0 ? "notification-badge" : "notification-badge notification-badge-waiting"

			if(notificationCount != 0) {
				Common.CreateNotification({body: "There are replies waiting in your inbox."}, 1000)
			}
		})
	}
})

function clickLogin() {
	loginPage(false)
}

function loginPage(type) {
	Common.loginContext.update(l => "add-item/" + type)
	Common.CreateNotification({body: "You must login to contribute!"}, 1000)
	push('/login')
}

function makeItemAdder(ItemType) {
	return function() {
		/*
		if(!currentUser) {
			loginPage(ItemType);
			return
		}
		*/
	
		push('/add-item/' + ItemType)
	}
}

function makeMunItemAdder(ItemType) {
	return function() {
		if(!currentUser) {
			loginPage(ItemType);
			return
		}

		push("/area/" + currentUserArea.id)
		setTimeout(() => {
			replace('/add-item/' + ItemType)
		}, 100)
	}
}

const unsubsribe = Common.currentUser.subscribe(value => {
	currentUser = value

	if(!currentUser)
		return
	if(currentUser.user_area_id != 0){
		Common.getData('area/' + currentUser.user_area_id)
		.then(data => {
			currentUserArea = data
		})
	}
})

function logOut() {
	Common.logUserOut();
}

function goHome() {
	push('/')
}

function goToAreaMaker(area_id) {
	return function () {
		push('/area/' + area_id);
		searchQuery = ""
	}
}

function goToContact() {
	push('/contact')
	searchQuery = ""
}

let requestPending = false
function areaSearchChange() {
	if(searchQuery.length==0 || requestPending) {
		return
	}
	requestPending = true
	filteredTags = null
	filteredAreas = null

	setTimeout(() => {
		if(searchQuery.length==0) {
			requestPending = false
			return
		}
		Common.getData('areas-search/' + searchQuery)
		.then(data => {
			filteredAreas = data
		})

		Common.getData('tags-search/' + searchQuery)
		.then(data => {
			filteredTags = data
		})
		requestPending = false
	}, 1000)
}

function goToTag(tag) {
	searchQuery = ""
	push('/tag/' + tag)
}

</script>

<div id="header">
	<div id="logo-and-menu">
		<div on:click={goHome} id="logo">
			<img class="logo-img" src="/logo3_black_icon.png" alt="Plan Together Logo"><div class="logo-text">plan together</div>
		</div>

		<div id="controls">
			<div class="controls-holder">
				<div style="display: flex; flex-direction: row">
					<div>
						<button on:click={makeItemAdder(Common.ITEMTYPE_NEWS)} class="add-button">
							+ Add To Map
						</button>
					</div>

					
					{#if !Common.isMobile()}
						<div>
							<button on:click={() => push('/tools/incoming')} class="tools-button">
								Municipal Tools
							</button>
						</div>
					{/if}
					<div>
						<button id="menu-button" on:click={() => showExtendedBar = !showExtendedBar} class="tools-button">
							{#if showExtendedBar}Close {:else}Menu{/if}
						</button>
					</div>
				</div>
			</div>
		</div>
		<!--<div id="menu-button" on:click={() => showExtendedBar = !showExtendedBar} >
			<div class="hamb-holder">
				<div class="hamb"></div>
				<div class="hamb"></div>
				<div class="hamb"></div>
			</div>
		</div>-->
	</div>

	{#if showExtendedBar}
		<div id="extended-bar-holder" transition:slide='{{duration:250}}'>
			{#if !municipalUser}
				<div id="search">
					<input class="search-input" placeholder="Search Areas, Tags..." bind:value={searchQuery} on:input={areaSearchChange}>
					{#if searchQuery.length != 0}
						<div class="search-suggestions">
							<div class="search-suggestion-header">
								Areas
							</div>
							{#if filteredAreas === null}
								<Spinner></Spinner>
							{:else if filteredAreas.length != 0}
								{#each filteredAreas as area}
									<div class="search-result" on:click={goToAreaMaker(area.id)}>
										{area.name}, {area.country}
									</div>
								{/each}
							{:else}
								<div class="search-result" on:click={goToContact}>
									Area Not Enabled. Click to Request.
								</div>
							{/if}
							<div class="search-suggestion-header">
								Tags
							</div>
							{#if filteredTags === null}
								<Spinner></Spinner>
							{:else if filteredTags.length != 0}
								{#each filteredTags as tag}
									<div class="search-result" on:click={() => goToTag(tag)}>
										# {tag}
									</div>
								{/each}
							{:else}
								<div class="search-result">
									No tags found.
								</div>
							{/if}
						</div>
					{/if}
				</div>
			{/if}
			<div id="links">
				{#if Common.isMobile()}
					<a href="https://plantogether.city/tools-landing">Municipal Tools</a>
				{/if}
				<a href="#/about">About</a>
				<a href="#/areas">Areas</a>
				<a href="#/policies">Policies</a>
				<a href="#/contact">Contact Us</a>
				<a href="https://blog.plantogether.city">Blog</a>

				{#if currentUser}
					<a class={inboxLinkClass} href="#/inbox/">
						Inbox
						{#if notificationCount}<span class={inboxBadgeClass}>{notificationCount}</span>{/if}
					</a>
					<div class="dropdown">
						<span class="username-display">{currentUser.user_name}</span>
						<div class="dropdown-content">
							{#if currentUserArea}
								<div class="verified-badge-holder">
									<span class="badge">{currentUserArea.name} Area Offical</span>
								</div>
							{/if}
							{#if currentUser.user_special}
								<div class="verified-badge-holder">
									<span class="badge-special">{Common.getSpecialStr(currentUser.user_special)}</span>
								</div>
							{/if}
							<a href={"#/user/" + currentUser.user_id }>Profile</a>
							<a href="#/account">Account</a>
							<a on:click={logOut}>Logout</a>
						</div>
					</div>
				{:else}
					<a href="#/login" >Login/Sign Up</a>
				{/if}
			</div>
		</div>
		{/if}
</div>